import { createSlice } from '@reduxjs/toolkit';
import type { Match, Player, Stage, Team } from 'modules/client/tournaments/domain/types';
import type { ChampionshipDto } from 'modules/client/tournaments/domain/types/dtos';
import { createFetchChampionshipInfoReducer } from 'modules/client/tournaments/store/client-tournament/reducers';

export interface ClientTournamentSliceState {
  loading: boolean;
  loaded: boolean;
  error: string | null;

  teams: Team[];
  players: Player[];
  stages: Stage[];
  matches: Match[];
  championship: ChampionshipDto | null;
}

const initialState: ClientTournamentSliceState = {
  loading: false,
  loaded: false,
  error: null,

  teams: [],
  players: [],
  stages: [],
  matches: [],
  championship: null,
};

export const clientTournamentSlice = createSlice({
  name: 'clientTournament',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createFetchChampionshipInfoReducer(builder);
  },
});

export const {} = clientTournamentSlice.actions;

export default clientTournamentSlice.reducer;
